import React, { useEffect } from 'react';
import ReactDOM from 'react-dom';

interface ModalProps {
    onClose: () => void;
    width?: string;
    children: React.ReactNode;
}

const Modal: React.FC<ModalProps> = ({ onClose, children, width = "650" }) => {
    useEffect(() => {
        document.body.classList.add("modal-open");
        return () => {
            document.body.classList.remove("modal-open");
        };
    }, []);

    const handleClose = () => {
        document.body.classList.remove("modal-open");
        onClose();
    };

    return ReactDOM.createPortal(
        <>
            <div className="modal-backdrop fade show" onClick={handleClose}></div>
            <div
                className="modal fade show d-block"
                tabIndex={-1}
                role="dialog"
            >
                <div
                    className="modal-dialog  modal-dialog-scrollable modal-dialog-centered flex-column flex-md-row justify-content-end justify-content-md-start mx-0 mx-md-auto "
                    role="document"
                    style={{ maxWidth: `${width}px` }}
                >
                    <div className="modal-content border-0 radius-5px mobile-radius-y-0 overflow-visible overflow-md-hidden">
                        {children}
                    </div>
                </div>
            </div>
        </>,
        document.body
    );
};

export default Modal;
